module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABGdBTUEAALGPC/xhBQAAAQdJREFUSA3tVsEOgjAMbcGDMZ7UHyTRk1z1I+RkAic1/KB6MsYLqSvJkm3pkBGcF7lsa19f2zdoQBCeojzfCGghuDpNCHjf5etlJ0g7D+WJ9D5k9cUlISRDsf8kQcpFkQuL6nIEoC0RpUHl9QAjYgOA1YQTrGbpPMuyV4+4IEhd19Prs3kk3ME3EnA1zMv8Ue5EyTXeY37x+3yDmnnUJCaxTsBrFLmiJLHkMjU12x2yt6STiCVbn0RSHNviyyVVK1Xn4ixpXKc6W3ci+OETgRTj2hIeYjxjXMcYZ+ZlftUJVjzElCziFA6Vy8Qr3nYKiwWbQBHgMfrifvd28f+TrypPE62Z4yT/G3G/Yyr5nhMuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/assets/Printer.png
// module id = ./src/layouts/PageLayout/assets/Printer.png
// module chunks = 1